import styled from 'styled-components';

export const FlightDetailCardWrapper = styled.div`
  > * + * {
    margin-top: 16px;
  }
`;
